import { render, staticRenderFns } from "./DefaultFooter.vue?vue&type=template&id=c5dd699c&scoped=true"
import script from "./DefaultFooter.vue?vue&type=script&lang=js"
export * from "./DefaultFooter.vue?vue&type=script&lang=js"
import style0 from "./DefaultFooter.vue?vue&type=style&index=0&id=c5dd699c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5dd699c",
  null
  
)

export default component.exports